module.exports = __webpack_public_path__ + "img/20210619_172145.f885f4af.jpg";